// Data catalog route - browse datapoints with filtering, wrapped in Data Hub layout

import { createFileRoute } from '@tanstack/react-router';

import { DataCatalogPage } from '@/features/datahub/components/DataCatalogPage';
import { DataHubLayout } from '@/features/datahub/components/DataHubLayout';

export const Route = createFileRoute('/_authenticated/datahub/datapoints/')({
  component: DataCatalogWithLayout,
});

function DataCatalogWithLayout() {
  return (
    <DataHubLayout activeTab="catalog">
      <DataCatalogPage />
    </DataHubLayout>
  );
}
